/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Material
 */
export interface Material {
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    materialType: string;
    /**
     * 
     * @type {Date}
     * @memberof Material
     */
    availableDate: Date;
}

/**
 * Check if a given object implements the Material interface.
 */
export function instanceOfMaterial(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "materialType" in value;
    isInstance = isInstance && "availableDate" in value;

    return isInstance;
}

export function MaterialFromJSON(json: any): Material {
    return MaterialFromJSONTyped(json, false);
}

export function MaterialFromJSONTyped(json: any, ignoreDiscriminator: boolean): Material {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'materialType': json['materialType'],
        'availableDate': (new Date(json['availableDate'])),
    };
}

export function MaterialToJSON(value?: Material | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'materialType': value.materialType,
        'availableDate': (value.availableDate.toISOString()),
    };
}

